import { ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, Output } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { CallState } from '@lcs/shared/api';
import { Actions, ofType } from '@ngrx/effects';
import { ExtensionTypes } from 'generated/graphql-types';
import { ExtensionGroupDetailView } from '../../extension-group-details/models/extension-group-detail-view.model';
import { ExtensionGroupPrivileges } from '../../extension-group-details/models/extension-group-privileges';
import { AddExtensionGroupData } from '../models/add-extension-group-data';
import * as addExtensionGroup from '../state/add-extension-group.actions';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-add-extension-group-view',
    styleUrls: ['./add-extension-group-view.component.scss'],
    templateUrl: './add-extension-group-view.component.html',
    standalone: false
})
export class AddExtensionGroupViewComponent {
   @Output() formSubmitted = new EventEmitter<AddExtensionGroupData>();

   @Output() formCanceled = new EventEmitter<void>();

   @Input() form: UntypedFormGroup;

   @Input() extensionGroup: ExtensionGroupDetailView;

   @Input() callState: CallState;

   @Input() accountId: number | null;

   @Input() set extensionGroupPrivileges(privileges: ExtensionGroupPrivileges) {
      this._extensionGroupPrivileges = privileges;
   }

   get extensionGroupPrivileges(): ExtensionGroupPrivileges {
      return this._extensionGroupPrivileges;
   }

   constructor(private actions$: Actions, private changeDetectorRef: ChangeDetectorRef) {}

   searchControl = new UntypedFormControl('');

   extensionGroupMemberTypes = [ExtensionTypes.Phone];

   private _extensionGroupPrivileges: ExtensionGroupPrivileges;

   ngOnInit() {
      this.actions$.pipe(ofType(addExtensionGroup.createExtensionGroupSuccess)).subscribe(() => {
         this.clearExtensionGroupFields();
         this.form.markAsPristine();
         this.form.markAsUntouched();
      });
   }

   clearExtensionGroupFields() {
      this.form.get('name')?.setValue('');
      this.form.get('description')?.setValue('');
      this.form.get('extensionGroupExtensions')?.setValue(null);
      this.changeDetectorRef.markForCheck();
   }

   onCloseClick(): void {
      this.formCanceled.emit();
   }

   onCreate(): void {
      if (this.form.valid) {
         this.formSubmitted.emit();
      } else {
         this.form.controls.extensionGroupExtensions.markAsDirty();
         this.form.controls.extensionGroupExtensions.markAsTouched();
      }
   }

   emitAddExtensionGroupExtensionsChange() {
      this.form.get('extensionGroupExtensions')?.markAsDirty();
   }
}
